<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TypeaheadFormGroup
            v-model="data.portal_company_id"
            name="portal_company_id"
            label="Company"
            help-text="The company that bought the sponsorship."
            :error="(errors.portal_company_id || [])[0]"
            endpoint="/api/v2/portal-companies"
            :params="{'filter[portal_id]': portal.id}"
            :token="shared.token"
            path="data.data"
            :result-label-property="row => row.attributes.name"
            :initial-label="data.portal_company_name"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {SubmitFormGroup, TypeaheadFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    portal: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  }
}
</script>